module.exports = __webpack_public_path__ + "img/17.754ded24.png";